import React from 'react';

// material
import { Button, Card, CardContent, Grid, withStyles} from '@material-ui/core';
// styles
import styles from './personal-info-card-styles';

const PersonalInfoCardView = (props)=> {
  const {
    classes,
    isLoading,
    userDetails
  } = props;

  return(
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
          <Grid item>Personal Info</Grid>
          <Grid item>
            <Button
              color={'primary'}
              size={'small'}
              variant={'contained'}
              onClick={() => props.toggleEdit()}>
              Edit
            </Button>
          </Grid>
        </Grid>
        {
          !isLoading && 
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item>Name :</Grid>
                <Grid item>
                  {userDetails.firstName === '' ? '' : userDetails.firstName} 
                  {userDetails.firstName === '' ||  userDetails.lastName === '' ? '' : ' '}
                  {userDetails.lastName === '' ? '' : userDetails.lastName}
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item>Phone :</Grid>
                <Grid item>
                  {userDetails.phoneNumber === null ? '-' : userDetails.phoneNumber}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (PersonalInfoCardView);